// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleRail_root__1oWnZ","label":"ArticleRail_label__142PO"};